// Reusable 4x6 Target carton SSCC-18 label (GS1-128 + (420) postal barcodes); mapped identity.
// Generated by scripts/wms/generate.ts for PHP-410. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomTargetCartonSsccLabelFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  targetDC: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  postalCode: yup.string().nullable().optional(),
  postalBarcode: yup.string().nullable().optional(),
  carrier: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  distributionCenter: yup.string().nullable().optional(),
  dpci: yup.string().nullable().optional(),
  casepack: yup.string().nullable().optional(),
  style: yup.string().nullable().optional(),
  upc: yup.string().nullable().optional(),
  size: yup.string().nullable().optional(),
  productDescription: yup.string().nullable().optional(),
  vendorSku: yup.string().nullable().optional(),
  cartonSscc: yup.string().nullable().optional(),
  cartonSsccBarcode: yup.string().nullable().optional(),
})

export type BiomTargetCartonSsccLabelFileData = yup.InferType<
  typeof biomTargetCartonSsccLabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomTargetCartonSsccLabelFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomTargetCartonSsccLabelFileMappings: RequiredFileData = {
  customerDisplayName: 'beb216a2-ade0-4043-835d-1c5cac7f2864',
  shipFromAddress: 'c5fb99fc-0c43-495c-aa3a-7c7707bef18f',
  targetDC: '22ca294d-207b-4a38-adce-993394d7626a',
  shipToAddress: '891d45ae-db6f-40ed-9d47-ad4f582ac47e',
  postalCode: '57d70af3-5f5b-40fd-861c-2f4a03900826',
  postalBarcode: '7e065061-d990-4d59-998c-59c9cb68e9d5',
  carrier: '9e0097b7-63b6-478a-b184-b8e6ec87214c',
  poNumber: '2b2257da-4397-4c90-8915-02576a4a1697',
  distributionCenter: '9bf836f9-b916-447c-ad26-fca2318b6f13',
  dpci: 'ef423191-635c-43d9-b71f-8d056a3aa3a4',
  casepack: '14563471-8d41-4645-9c95-173cde012b00',
  style: 'c0d79ab4-fa5d-4c69-bc56-f4cead8707a7',
  upc: '59dec502-21f8-49b7-a619-bb4536dcb691',
  size: 'b7eec824-d2a9-4253-bc8f-45e28efbd6df',
  productDescription: '8c6d1c0b-d31e-43a3-a23b-1e2b2abb3473',
  vendorSku: 'aa100eaa-9d57-4e43-bc9c-a71d4cf87b01',
  cartonSscc: 'c1575947-0f86-4d86-bae9-9eeacbed7589',
  cartonSsccBarcode: '605e3807-9677-456e-b2d1-aae6c7cc1b3a',
}
